export type QuizStyleKey = 'romantic' | 'sculptural' | 'earthy' | 'zen';

export const quizStyles: Record<QuizStyleKey, { emoji: string; title: string; description: string }> = {
	romantic: {
		emoji: '🌸',
		title: 'Romantic Cottage Garden',
		description: 'Soft flowers, winding paths, and cozy corners full of charm.'
	},
	sculptural: {
		emoji: '🟪',
		title: 'Modern Sculptural Garden',
		description: 'Clean geometry, statement planting, and a sharp contemporary feel.'
	},
	earthy: {
		emoji: '🌞',
		title: 'Mediterranean Earthy Garden',
		description: 'Sun-loving textures, warm tones, and low-maintenance planting.'
	},
	zen: {
		emoji: '🧘',
		title: 'Japanese Zen Garden',
		description: 'Calm structure, balanced greenery, and a peaceful retreat energy.'
	}
};

export type QuizOption = {
	label: string;
	emoji: string;
	scores: Partial<Record<QuizStyleKey, number>>;
};

export const quizQuestions: { prompt: string; icon: string; options: QuizOption[] }[] = [
	{
		prompt: "What's your garden vibe?",
		icon: '✨',
		options: [
			{ label: 'Wild & romantic', emoji: '🌸', scores: { romantic: 2, earthy: 1 } },
			{ label: 'Clean & sculptural', emoji: '🟪', scores: { sculptural: 2, zen: 1 } },
			{ label: 'Sun-drenched & earthy', emoji: '🌞', scores: { earthy: 2, romantic: 1 } },
			{ label: 'Peaceful & zen', emoji: '🧘', scores: { zen: 2, sculptural: 1 } }
		]
	},
	{
		prompt: 'How much time can you dedicate weekly?',
		icon: '⏰',
		options: [
			{ label: 'Almost none - keep it easy', emoji: '😌', scores: { earthy: 2, sculptural: 1 } },
			{ label: 'A couple of hours', emoji: '🌱', scores: { zen: 1, romantic: 1, earthy: 1, sculptural: 1 } },
			{ label: 'I love getting my hands dirty!', emoji: '🌻', scores: { romantic: 2, zen: 1 } },
			{ label: 'It depends on the season', emoji: '🍂', scores: { earthy: 1, romantic: 1, zen: 1 } }
		]
	},
	{
		prompt: 'What matters most to you?',
		icon: '🎯',
		options: [
			{ label: 'Beautiful flowers & colours', emoji: '🌹', scores: { romantic: 2 } },
			{ label: 'A space to relax & unwind', emoji: '🛖', scores: { zen: 2 } },
			{ label: 'Growing food & herbs', emoji: '🥬', scores: { earthy: 2 } },
			{ label: 'Wildlife & eco impact', emoji: '🦋', scores: { zen: 1, earthy: 1, romantic: 1 } }
		]
	}
];
